import { Box, Switch, type SwitchProps, Typography } from "@mui/joy";
import { switchClasses } from "@mui/joy";
import { memo } from "react";

const AudienceSwitch = memo<SwitchProps>(({ checked, ...rest }) => (
  <Box sx={(theme) => ({ my: theme.spacing(1), px: theme.spacing(1) })}>
    <Switch
      checked={checked}
      color="primary"
      size="md"
      {...rest}
      slotProps={{
        track: {
          children: (
            <>
              <Typography
                component="span"
                fontSize={9}
                level="inherit"
                sx={{
                  ml: "6px",
                }}
              >
                And
              </Typography>
              <Typography
                component="span"
                fontSize={9}
                level="inherit"
                sx={(theme) => ({
                  color: theme.palette.background.body,
                  mr: "6px",
                })}
              >
                Or
              </Typography>
            </>
          ),
        },
      }}
      sx={(theme) => ({
        "&.Mui-checked": {
          "&:hover": {
            "--Switch-trackBackground": theme.palette.primary[500],
          },
          "--Switch-thumbBackground": "white",
          "--Switch-trackBackground": theme.palette.primary[500],
        },
        [`& .${switchClasses.thumb}`]: {
          transition: "width 0.2s, left 0.2s",
        },
        "&:hover": {
          "--Switch-trackBackground": theme.palette.secondary[500],
        },
        "--Switch-thumbBackground": "white",
        "--Switch-thumbSize": "22px",
        "--Switch-trackBackground": theme.palette.secondary[500],
        "--Switch-trackHeight": "26px",
        "--Switch-trackWidth": "50px",
      })}
    />
  </Box>
));

AudienceSwitch.displayName = "AudienceSwitch";

export default AudienceSwitch;
